import axios from 'axios'
import Vue from 'vue'
import * as types from '../mutation-types'

// state
export const state = {
    listDescriptions: [],
    formDescriptions: [],
    mockData: [],
}

// getters
export const getters = {
    listDescription: state => (slug) => {
        return state.listDescriptions[slug]
    },
    formDescription: state => (slug) => {
        return state.formDescriptions[slug]
    },
    mockData: state => (slug) => {
        return state.mockData[slug]
    }
}

// mutations
export const mutations = {
    [types.FETCH_LIST_DESCRIPTION_SUCCESS](state, {slug, description}) {
        Vue.set(state.listDescriptions, slug, description)
    },

    [types.FETCH_LIST_DESCRIPTION_FAILURE](state) {
        // ?
    },

    [types.FETCH_FORM_DESCRIPTION_SUCCESS](state, {slug, description}) {
        Vue.set(state.formDescriptions, slug, description)
    },

    [types.FETCH_FORM_DESCRIPTION_FAILURE](state) {
        // ?
    },

    [types.FETCH_MOCK_DATA_DESCRIPTION_SUCCESS](state, {slug, mockData}) {
        Vue.set(state.mockData, slug, mockData)
    },

    [types.FETCH_MOCK_DATA_DESCRIPTION_FAILURE](state) {
        // ?
    },
}

// actions
export const actions = {
    async fetchList({commit}, slug) {
        try {
            const {data} = await axios.get(`${config.appUrl}/api/${slug}/describe-list`)

            commit(types.FETCH_LIST_DESCRIPTION_SUCCESS, {slug, description: data.description})
        } catch (e) {
            commit(types.FETCH_LIST_DESCRIPTION_FAILURE)
        }
    },

    async fetchForm({commit}, slug) {
        try {
            const {data} = await axios.get(`${config.appUrl}/api/${slug}/describe-form`)

            commit(types.FETCH_FORM_DESCRIPTION_SUCCESS, {slug, description: data.description})
        } catch (e) {
            commit(types.FETCH_FORM_DESCRIPTION_FAILURE)
        }
    },

    async fetchMockData({commit}, slug) {
        try {
            const {data} = await axios.get(`${config.appUrl}/api/${slug}/form-mock-data`)

            commit(types.FETCH_MOCK_DATA_DESCRIPTION_SUCCESS, {slug, mockData: data.data})
        } catch (e) {
            commit(types.FETCH_MOCK_DATA_DESCRIPTION_FAILURE)
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/crud.js